import { render, staticRenderFns } from "./LearningGroupEdit.vue?vue&type=template&id=48cd27b7&"
import script from "./LearningGroupEdit.vue?vue&type=script&lang=ts&"
export * from "./LearningGroupEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports